<div class="header-backdrop" [class.show]="parent.headerShared.hasMegaMenu(activeMegaMenu)"></div>

<header [ngClass]="[breakpointClass]">
    <div class="header-wrapper" [ngClass]="{ searching: (parent.toggleSearchBar$ | async) == true }">
        <a
            class="home"
            [routerLink]="homeRoutePath"
            [queryParams]="{ product: (parent.selectedProduct$ | async)?.uid }"
            (click)="parent.scrollToTop()"
            aria-label="Home"
            data-testId="home">
            <mat-icon [svgIcon]="'app_logo'" aria-hidden></mat-icon>
        </a>

        <app-mega-menu
            [isVisible]="activeMegaMenu === 'Resources'"
            [title]="'Discover the tools that can help you succeed'"
            [menuSections]="parent.resourcesMegaMenu$ | async"
            [queryParams]="{ product: (parent.selectedProduct$ | async)?.uid }"
            (mouseenter)="showMegaMenu('Resources')"
            (mouseleave)="hideMegaMenu()">
        </app-mega-menu>

        <app-mega-menu
            [isVisible]="activeMegaMenu === 'Support'"
            [title]="'Get the support you need'"
            [menuSections]="parent.supportMegaMenu$ | async"
            [queryParams]="{ product: (parent.selectedProduct$ | async)?.uid }"
            (mouseenter)="showMegaMenu('Support')"
            (mouseleave)="hideMegaMenu()">
        </app-mega-menu>

        <div class="dynamic">
            <div class="nav-wrapper" (mouseleave)="hideMegaMenu()">
                <nav>
                    <div *ngFor="let route of parent.headerShared.routes" class="nav-item">
                        <a
                            [routerLink]="parent.headerShared.isClickableRoute(route.label) ? route.routerLink : null"
                            [queryParams]="{ product: (parent.selectedProduct$ | async)?.uid }"
                            (click)="parent.scrollToTop()"
                            [tabindex]="(parent.toggleSearchBar$ | async) == true ? -1 : ''"
                            [attr.data-testId]="route.routerLink.replace('/', '')"
                            (mouseenter)="showMegaMenu(route.label)"
                            (focus)="showMegaMenu(route.label)"
                            [class.active]="activeMegaMenu === route.label"
                            [class.currentPage]="
                                parent.headerShared.isRouteActive(route.routerLink, parent.activePage)
                            ">
                            {{ route.label }}
                        </a>
                    </div>
                </nav>

                <div class="product-select-wrapper">
                    <app-header-product-select [tabIndex]="(parent.toggleSearchBar$ | async) == true ? -1 : ''">
                    </app-header-product-select>
                </div>
            </div>

            <app-header-search-bar
                [isOpen]="(parent.toggleSearchBar$ | async) == true"
                [tabIndex]="(parent.toggleSearchBar$ | async) == true ? '' : -1"
                (afterSearch)="parent.toggleSearchBar()">
            </app-header-search-bar>
        </div>

        <button
            class="icon search"
            (click)="parent.toggleSearchBar($event)"
            [matTooltip]="(parent.toggleSearchBar$ | async) == true ? 'Close' : 'Search'"
            [matTooltipShowDelay]="1000"
            [matTooltipHideDelay]="2000"
            aria-label="Search">
            <mat-icon [svgIcon]="(parent.toggleSearchBar$ | async) == true ? 'close' : 'search'" aria-hidden></mat-icon>
        </button>

        <button
            *appAuthed
            class="icon ai"
            (click)="openAMA()"
            [matTooltip]="AMA_TITLE"
            [matTooltipShowDelay]="1000"
            [matTooltipHideDelay]="2000"
            [attr.aria-label]="environment.customerAssistant.label">
            <mat-icon [svgIcon]="'ai'" aria-hidden></mat-icon>
        </button>

        <button
            class="icon pendo"
            id="gkn-announcements"
            matTooltip="Announcements"
            [matTooltipShowDelay]="1000"
            [matTooltipHideDelay]="2000"
            aria-label="Announcements">
            <div class="pendo-icon-wrapper">
                <mat-icon [svgIcon]="'bullhorn'" aria-hidden></mat-icon>
            </div>
        </button>

        <button
            class="icon user"
            aria-label="My Account"
            matTooltip="My Account"
            [matTooltipShowDelay]="1000"
            [matTooltipHideDelay]="2000"
            [matMenuTriggerFor]="menu"
            (click)="closePendoResourceCenter()">
            <mat-icon *appUnauthed [svgIcon]="'user'" aria-hidden></mat-icon>
            <div *appAuthed class="initials" aria-hidden>
                <div *ngIf="parent.pfpLink$ | async as pfpLink; else initialsOnly" class="pfp-wrapper">
                    <img [src]="pfpLink" alt="Profile picture" />
                </div>
                <ng-template #initialsOnly>
                    <span
                        *ngIf="parent.initialsColors$ | async as colors"
                        [style.background-color]="colors.backgroundColor"
                        [style.color]="colors.textColor"
                        >{{ parent.initials$ | async }}</span
                    >
                </ng-template>
                <mat-icon [svgIcon]="'chevron_down'" aria-hidden></mat-icon>
            </div>
        </button>

        <mat-menu
            #menu="matMenu"
            xPosition="before"
            [overlapTrigger]="false"
            backdropClass="profile-dropdown-backdrop"
            class="profile-dropdown-panel">
            <button
                *appUnauthed
                mat-menu-item
                (click)="parent.signIn($event)"
                matTooltip="Sign in with Okta"
                [matTooltipShowDelay]="1000"
                [matTooltipHideDelay]="2000"
                aria-haspopup="dialog"
                data-testId="sign-in">
                {{ GknRouteLabel.SIGN_IN }}
            </button>
            <a
                *appUnauthed
                mat-menu-item
                [routerLink]="'/' + GknRoutePath.SIGNUP"
                [queryParams]="{ product: (parent.selectedProduct$ | async)?.uid }"
                [matTooltip]="'Visit the ' + GknRouteLabel.SIGN_UP + ' page'"
                [matTooltipShowDelay]="1000"
                [matTooltipHideDelay]="2000"
                data-testId="sign-up">
                {{ GknRouteLabel.SIGN_UP }}
            </a>
            <a
                *appAuthed
                mat-menu-item
                [routerLink]="'/' + GknRoutePath.PROFILE"
                [queryParams]="{ product: (parent.selectedProduct$ | async)?.uid }"
                matTooltip="View my profile"
                [matTooltipShowDelay]="1000"
                [matTooltipHideDelay]="2000"
                data-testId="my-profile">
                {{ GknRouteLabel.PROFILE }}
            </a>
            <button
                *appAuthed
                mat-menu-item
                (click)="openBillingDialog()"
                matTooltip="Access Billing"
                [matTooltipShowDelay]="1000"
                [matTooltipHideDelay]="2000"
                data-testId="billing-dialog">
                Billing
            </button>
            <!-- Achiever's Lounge -->
            <a
                *appAuthed
                mat-menu-item
                [routerLink]="'/' + GknRoutePath.PROFILE + '/' + ChildPageRoute.ACHIEVERS_LOUNGE"
                [queryParams]="{ product: (parent.selectedProduct$ | async)?.uid }"
                [matTooltip]="'Visit the ' + orchestratorsRouteLabel.ACHIEVERS_LOUNGE + ' page'"
                [matTooltipShowDelay]="1000"
                [matTooltipHideDelay]="2000"
                data-testId="achievers-lounge">
                {{ orchestratorsRouteLabel.ACHIEVERS_LOUNGE }}
            </a>
            <!-- User Management -->
            <a
                *designatedApprover
                mat-menu-item
                routerLink="/user-management"
                [queryParams]="{ product: (selectedProduct$ | async)?.uid }"
                [matTooltip]="'View the ' + orchestratorsRouteLabel.USER_MANAGEMENT + ' page'"
                [matTooltipShowDelay]="1000"
                [matTooltipHideDelay]="2000"
                data-testId="user-management">
                {{ orchestratorsRouteLabel.USER_MANAGEMENT }}
            </a>
            <button
                *appAuthed
                mat-menu-item
                (click)="parent.signOut($event)"
                matTooltip="Sign out of Okta"
                [matTooltipShowDelay]="1000"
                [matTooltipHideDelay]="2000"
                data-testId="sign-out">
                Sign Out
            </button>
            <div *appAuthed class="debug-menu">
                @if (!environment.production) {
                    <p>
                        <mat-icon color="warn">keyboard_double_arrow_down</mat-icon>
                        {{ environment.name | uppercase }} ONLY
                        <mat-icon color="warn">keyboard_double_arrow_down</mat-icon>
                    </p>
                    <hr />
                    <a
                        mat-menu-item
                        [routerLink]="'/' + GknRoutePath.DESIGN"
                        [queryParams]="{ product: (parent.selectedProduct$ | async)?.uid }"
                        [matTooltip]="'View the ' + orchestratorsRouteLabel.DESIGN + ' page'"
                        [matTooltipShowDelay]="1000"
                        [matTooltipHideDelay]="2000"
                        data-testId="design">
                        {{ orchestratorsRouteLabel.DESIGN }}
                    </a>
                    <a
                        mat-menu-item
                        [routerLink]="'/' + GknRoutePath.STATUS"
                        [queryParams]="{ product: (parent.selectedProduct$ | async)?.uid }"
                        [matTooltip]="'View the ' + orchestratorsRouteLabel.STATUS + ' page'"
                        [matTooltipShowDelay]="1000"
                        [matTooltipHideDelay]="2000"
                        data-testId="status">
                        {{ orchestratorsRouteLabel.STATUS }}
                    </a>
                    <button
                        mat-menu-item
                        [matTooltipShowDelay]="1000"
                        [matTooltipHideDelay]="2000"
                        [matMenuTriggerFor]="utilitiesMenu">
                        Test Utilities
                    </button>
                    <mat-menu #utilitiesMenu="matMenu">
                        <a
                            mat-menu-item
                            [routerLink]="'/' + GknRoutePath.RENEWAL_TEST"
                            [queryParams]="{ product: (parent.selectedProduct$ | async)?.uid }"
                            matTooltip="Test renewal flow"
                            [matTooltipShowDelay]="1000"
                            [matTooltipHideDelay]="2000"
                            data-testId="renewal-test">
                            Auto Renewals
                        </a>
                        <a
                            mat-menu-item
                            routerLink="/kepler-test"
                            [queryParams]="{ product: (parent.selectedProduct$ | async)?.uid }"
                            matTooltip="Test Kepler services"
                            [matTooltipShowDelay]="1000"
                            [matTooltipHideDelay]="2000"
                            data-testId="kepler-test">
                            Kepler Services
                        </a>
                    </mat-menu>
                    <hr />
                    <div mat-menu-item (click)="$event.stopPropagation()" data-testId="debug-toggle">
                        <mat-slide-toggle
                            labelPosition="before"
                            [checked]="debugService.isDebugMode$ | async"
                            (change)="debugService.setDebugMode($event.checked)"
                            color="primary">
                            Debug
                        </mat-slide-toggle>
                    </div>
                    <ul class="features">
                        @for (feature of debugService.featureList; track $index) {
                            <li>
                                <p>{{ feature }}</p>
                                <mat-icon
                                    [svgIcon]="(debugService.isDebugMode$ | async) == true ? 'check' : 'close'"
                                    [class.active]="debugService.isDebugMode$ | async"
                                    aria-hidden></mat-icon>
                            </li>
                        }
                    </ul>
                }
            </div>
        </mat-menu>
    </div>
</header>
